import { Spinner } from '../../components/Spinner.js';
import { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router';
import { apiClient } from '../../lib/api-client.js';

interface SpotSummary {
  id: string;
  name: string;
  category: string;
  address: string | null;
  createdAt: string;
}

export function UserSpotListView() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [spots, setSpots] = useState<SpotSummary[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!id) return;
    apiClient
      .get<SpotSummary[]>(`/users/${id}/spots`)
      .then((data) => {
        if (data) setSpots(data);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [id]);

  return (
    <div className="p-4 max-w-lg mx-auto">
      <div className="flex items-center gap-3 mb-6">
        <button
          onClick={() => navigate(-1)}
          className="text-gray-500 hover:text-gray-700"
          aria-label="戻る"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15 18L9 12L15 6"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
        <h1 className="text-xl font-bold">登録したスポット</h1>
      </div>

      {loading && (
        <div className="flex justify-center py-8">
          <Spinner />
        </div>
      )}

      {!loading && spots.length === 0 && (
        <p className="text-center py-8 text-gray-500">登録したスポットはありません</p>
      )}

      {!loading && spots.length > 0 && (
        <div className="bg-white rounded-lg border border-gray-100 divide-y divide-gray-100">
          {spots.map((spot) => (
            <Link
              key={spot.id}
              to={`/spots/${spot.id}`}
              className="flex justify-between items-start px-4 py-3 text-sm"
            >
              <div className="flex-1 min-w-0 mr-3">
                <p className="text-gray-700 truncate">{spot.name}</p>
                {spot.address && (
                  <p className="text-xs text-gray-400 mt-0.5 truncate">{spot.address}</p>
                )}
              </div>
              <span className="text-gray-400 flex-shrink-0 text-xs mt-0.5">
                {new Date(spot.createdAt).toLocaleDateString('ja-JP')}
              </span>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
